'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import styles from './LoginForm.module.css';

export function LoginImagePanel() {
  const t = useTranslations('auth.loginImage');
  return <div className={styles.imagePanel}>
    <Image
      src="/images/auth/login-mesh-ice-blue.webp"
      alt={t('alt')}
      fill
      unoptimized
      priority
      sizes="(min-width: 904px) 424px, (min-width: 768px) 48.5vw, 0px"
      className={styles.image}
    />
  </div>;
}
